import SystemContent from "./Component/Dashboard/SystemContent";
import SystemAside from "./Component/SystemAside";
import SystemFooter from "./Component/SystemFooter";
import SystemHeader from "./Component/SystemHeader";

export default function SystemDashboard() {
    return <>
        <SystemHeader />
        <SystemAside />
        <SystemContent />
        <SystemFooter />
    </>
}